import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  admin,
  announce,
  announcement,
  apptime,
  help,
  history,
  link,
  overall,
  recharge,
  report,
  withdraw,
} from "../assets/img";
import { URLS } from "../Services/Constant";
import { post } from "../Services/ApiHandler";
import { toast } from "react-toastify";
import useStore from "../../src/LocalStore/useStore";
import { Toast } from "./Toast";

const ProfileNavbar = ({ setSaidList }) => {
  const [saideBarShow, setSaidBarShow] = useState(true);
  const [activeMenu, setActiveMenu] = useState(null);
  const [popup, setPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  const toggleSidebar = () => {
    setSaidBarShow(!saideBarShow);
    setActiveMenu(null);
  };

  const handleMenuClick = (menuKey, defaultRoute) => {
    setSaidBarShow(true);
    setActiveMenu((prev) => (prev === menuKey ? null : menuKey));
    if (activeMenu !== menuKey && defaultRoute) {
      navigate(defaultRoute);
    }
  };

  const handleLogout = async () => {
    try {
      setLoading(true);
      const res = await post(URLS.LOGOUT);
      // // console.log("res logout", res);
      if (res.status === "success") {
        Toast(res.message || "Logout Successfully!");
        useStore.getState().clear();
        setTimeout(() => {
          sessionStorage.clear();
          localStorage.removeItem("token");
          setLoading(false);
          setPopup(false);
          navigate("/", { replace: true });
        }, 1000);
      }
    } catch (err) {
      // // console.log("err logout", err);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Scroll to bottom when menu opens
  useEffect(() => {
    if (menuOpen && menuRef.current) {
      const el = menuRef.current;
      el.scrollTo({
        top: el.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [menuOpen]);

  const handleCloseMenu = () => {
    if (menuRef.current) {
      menuRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    setTimeout(() => setMenuOpen(false), 300); // wait for scroll then close
  };

  return (
    <div className={`${saideBarShow ? "sidebar" : "close_sidebar"}`}>
      <div onClick={toggleSidebar}>
        {saideBarShow ? (
          <KeyboardDoubleArrowLeftIcon className="arrow-right" />
        ) : (
          <KeyboardDoubleArrowRightIcon className="arrow-left" />
        )}
      </div>

      <div ref={menuRef} className="menu_bar overflow-x-hidden overflow-scroll">
        <div className="menu">
          <ul className="menu_links ps-0">
            <li
              className="nav_link trans"
              onClick={() => handleMenuClick("dashboard", "/dashboard")}
            >
              <h4
                className={`ps-3 ${
                  ["doc-verfication-mmc"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["doc-verfication-mmc"].includes(splitLocation[1])
                      ? admin
                      : admin
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Dashboard
                </span>
              </h4>
            </li>
            <li
              className="nav_link trans"
              onClick={() => handleMenuClick("admin", "/admin")}
            >
              <h4
                className={`ps-3 ${
                  ["doc-verfication-mmc"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["doc-verfication-mmc"].includes(splitLocation[1])
                      ? admin
                      : admin
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Admin
                </span>
              </h4>
            </li>
            <li className="nav_link trans" onClick={() => handleMenuClick("")}>
              <h4
                className={`ps-3 ${
                  ["doc-verfication-mmc"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["doc-verfication-mmc"].includes(splitLocation[1])
                      ? admin
                      : admin
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Roles Mapping
                </span>
              </h4>
            </li>
            <li className="nav_link trans" onClick={() => handleMenuClick("")}>
              <h4
                className={`ps-3 ${
                  ["doc-verfication-mmc"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["doc-verfication-mmc"].includes(splitLocation[1])
                      ? admin
                      : admin
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Client
                </span>
              </h4>
            </li>
            <li className="nav_link trans" onClick={() => handleMenuClick("")}>
              <h4
                className={`ps-3 ${
                  ["doc-verfication-mmc"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["doc-verfication-mmc"].includes(splitLocation[1])
                      ? recharge
                      : recharge
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Admin Recharge
                </span>
              </h4>
            </li>
            <li className="nav_link trans" onClick={() => handleMenuClick("")}>
              <h4
                className={`ps-3 ${
                  ["doc-verfication-mmc"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["doc-verfication-mmc"].includes(splitLocation[1])
                      ? history
                      : history
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Recharge History
                </span>
              </h4>
            </li>
            <li className="nav_link trans" onClick={() => handleMenuClick("")}>
              <h4
                className={`ps-3 ${
                  ["doc-verfication-mmc"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["doc-verfication-mmc"].includes(splitLocation[1])
                      ? withdraw
                      : withdraw
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Withdraw History
                </span>
              </h4>
            </li>
            <li className="nav_link trans" onClick={() => handleMenuClick("")}>
              <h4
                className={`ps-3 ${
                  ["doc-verfication-mmc"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["doc-verfication-mmc"].includes(splitLocation[1])
                      ? announce
                      : announce
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Announce Result
                </span>
              </h4>
            </li>
            <li className="nav_link trans" onClick={() => handleMenuClick("")}>
              <h4
                className={`ps-3 ${
                  ["doc-verfication-mmc"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["doc-verfication-mmc"].includes(splitLocation[1])
                      ? overall
                      : overall
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Overall Results
                </span>
              </h4>
            </li>
            <li className="nav_link trans" onClick={() => handleMenuClick("")}>
              <h4
                className={`ps-3 ${
                  ["doc-verfication-mmc"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["doc-verfication-mmc"].includes(splitLocation[1])
                      ? report
                      : report
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Reports
                </span>
              </h4>
            </li>
            <li className="nav_link trans" onClick={() => handleMenuClick("")}>
              <h4
                className={`ps-3 ${
                  ["doc-verfication-mmc"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["doc-verfication-mmc"].includes(splitLocation[1])
                      ? overall
                      : overall
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Commission History
                </span>
              </h4>
            </li>
            <li className="nav_link trans" onClick={() => handleMenuClick("")}>
              <h4
                className={`ps-3 ${
                  ["doc-verfication-mmc"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["doc-verfication-mmc"].includes(splitLocation[1])
                      ? announcement
                      : announcement
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Announcements
                </span>
              </h4>
            </li>
            <li className="nav_link trans" onClick={() => handleMenuClick("")}>
              <h4
                className={`ps-3 ${
                  ["doc-verfication-mmc"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["doc-verfication-mmc"].includes(splitLocation[1])
                      ? link
                      : link
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Links
                </span>
              </h4>
            </li>
            <li className="nav_link trans" onClick={() => handleMenuClick("")}>
              <h4
                className={`ps-3 ${
                  ["doc-verfication-mmc"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["doc-verfication-mmc"].includes(splitLocation[1])
                      ? overall
                      : overall
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Lot Price Details
                </span>
              </h4>
            </li>
            <li className="nav_link trans" onClick={() => handleMenuClick("")}>
              <h4
                className={`ps-3 ${
                  ["doc-verfication-mmc"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["doc-verfication-mmc"].includes(splitLocation[1])
                      ? apptime
                      : apptime
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  App Time Setting
                </span>
              </h4>
            </li>
            <li className="nav_link trans" onClick={() => handleMenuClick("")}>
              <h4
                className={`ps-3 ${
                  ["doc-verfication-mmc"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["doc-verfication-mmc"].includes(splitLocation[1])
                      ? help
                      : help
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Help & Support
                </span>
              </h4>
            </li>
          </ul>
        </div>
      </div>

      {/* Logout Button */}
      <div className="d-flex ac-jb py-3 px-2 bg-primary2">
        <h4
          onClick={() => setPopup(true)}
          className="f4 fs-md-13 fs-xl-16 mb-0 ms-4 pointer"
        >
          Logout
        </h4>
        {menuOpen ? (
          <KeyboardArrowUpIcon
            className="arrow-down "
            onClick={handleCloseMenu}
          />
        ) : (
          <KeyboardArrowDownIcon
            className="arrow-down "
            onClick={() => setMenuOpen(true)}
          />
        )}
      </div>

      {/* Logout Confirmation Popup */}
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <h2 className="f4 mt-4">Logout</h2>
            <p className="f3 mt-4">Are you sure, you want to logout?</p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setPopup(false)} className="add-btn w-40">
                No
              </button>
              <button onClick={handleLogout} className="back-btn f2 w-40">
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white", padding: 6 }}
                    ></span>
                  </>
                ) : (
                  "Confirm"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileNavbar;
